import React from 'react';
import { useLocation } from 'react-router-dom';

import { getFeatureFlags, IFeatureFlag } from '../queries/feature_flags/useFeatureFlags';
import analytics from '../services/analytics';
import authService from '../services/auth';

const setupFeatureFlags = (featureFlagsData: IFeatureFlag[]) => {
  if (featureFlagsData && Object.keys(window.__amp_feature_flags).length === 0) {
    featureFlagsData.forEach(
      feature_flag => window.__amp_feature_flags[feature_flag.feature_name] = feature_flag.enabled
    );
  }
};
const UserAuthenticationState = ({
  isAuthenticatedToBackend,
  setIsAuthenticatedToBackend
}: {
  isAuthenticatedToBackend: boolean;
  setIsAuthenticatedToBackend: (isAuthenticatedToBackend: boolean) => void;
}) => {

  React.useEffect(() => {
    const authInAmp = async () => {
      try {
        await authService.authenticate();

        const featureFlagsData = await getFeatureFlags();
        setupFeatureFlags(featureFlagsData.feature_flags);
        setIsAuthenticatedToBackend(true);
      } catch (_) {
        setIsAuthenticatedToBackend(false);
      }
    };

    authInAmp();
  }, [isAuthenticatedToBackend, setIsAuthenticatedToBackend]);

  const location = useLocation();

  React.useEffect(() => {
    analytics.page(location);
  }, [location]);

  return null;
};

export default UserAuthenticationState;
